import { Link } from 'react-router-dom';

/**
 * Постоянная комната совместного кодирования 1:1 (как телемост, без правки URL).
 */
export default function StudentCollabCell({ collabSessionId }) {
  const sid = (collabSessionId || '').trim();

  return (
    <div className="student-messenger" onClick={(e) => e.stopPropagation()}>
      {sid ? (
        <Link
          className="student-messenger-open"
          to={`/collaborative/${sid}`}
          onClick={(e) => e.stopPropagation()}
          title="Совместное кодирование"
        >
          <i className="fa-solid fa-code" aria-hidden />
          {' '}
          Код
        </Link>
      ) : (
        <span className="text-secondary student-messenger-empty">нет комнаты</span>
      )}
    </div>
  );
}
